module.exports = __webpack_public_path__ + "img/20190731163056838.35692a0a.png";